export const CONTRACT_TABLE_SORT_KEYS = Object.freeze([
  "contract_number",
  "company_name",
  "person_name",
  "owner_name",
  "status",
  "total_amount",
  "contract_date",
  "onboarding_count",
  "overdue_payment_count",
  "updated_at",
]);

export const CONTRACT_PAGE_SIZE_OPTIONS = Object.freeze([20, 50, 100, 200]);

export const parseNumeric = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const formatPart = (value) => String(value).padStart(2, "0");

export const parseDateTimeLikeParts = (value) => {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return {
      year: value.getFullYear(),
      month: value.getMonth() + 1,
      day: value.getDate(),
      hour: value.getHours(),
      minute: value.getMinutes(),
      second: value.getSeconds(),
    };
  }

  const normalized = String(value || "").trim();
  if (!normalized) return null;

  const directMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?$/);
  if (directMatch) {
    return {
      year: Number(directMatch[1]),
      month: Number(directMatch[2]),
      day: Number(directMatch[3]),
      hour: Number(directMatch[4] || 0),
      minute: Number(directMatch[5] || 0),
      second: Number(directMatch[6] || 0),
    };
  }

  const parsed = new Date(normalized);
  if (Number.isNaN(parsed.getTime())) return null;
  return {
    year: parsed.getFullYear(),
    month: parsed.getMonth() + 1,
    day: parsed.getDate(),
    hour: parsed.getHours(),
    minute: parsed.getMinutes(),
    second: parsed.getSeconds(),
  };
};

export const parseDateLikeParts = (value) => {
  const parts = parseDateTimeLikeParts(value);
  if (!parts) return null;
  return {
    year: parts.year,
    month: parts.month,
    day: parts.day,
  };
};

export const formatDisplayDateParts = (parts) => {
  if (!parts) return "-";
  return `${formatPart(parts.day)}.${formatPart(parts.month)}.${String(parts.year).padStart(4, "0")}`;
};

export const formatDisplayDateTimeParts = (parts) => {
  if (!parts) return "-";
  return `${formatDisplayDateParts(parts)}, ${formatPart(parts.hour)}:${formatPart(parts.minute)}`;
};

export const normalizeContractTableSortKey = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  if (!normalized) return null;
  return CONTRACT_TABLE_SORT_KEYS.includes(normalized) ? normalized : null;
};

export const normalizeContractTableSortOrder = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  if (!normalized) return null;
  return normalized === "asc" || normalized === "desc" ? normalized : null;
};

export const CONTRACTS_HOME_VIEW_PREFERENCE_KEY = "/ncrm/contracts";
